import React from "react";

// Crumpled-paper relief as an inline SVG overlay. Inline SVG filters render
// reliably across browsers (unlike SVG lighting filters inside CSS background
// data-URIs). Sits behind all content, multiplies onto the paper, hidden in print.
export const PaperTexture = () => (
  <div
    aria-hidden="true"
    data-testid="paper-texture"
    className="pointer-events-none fixed inset-0 -z-10 print:hidden"
    style={{ mixBlendMode: "multiply" }}
  >
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id="rq-paper-crumple" x="0" y="0" width="100%" height="100%">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.013"
          numOctaves="5"
          seed="7"
          result="noise"
        />
        <feDiffuseLighting
          in="noise"
          lightingColor="#ffffff"
          surfaceScale="3.4"
          diffuseConstant="1.15"
          result="light"
        >
          <feDistantLight azimuth="235" elevation="55" />
        </feDiffuseLighting>
      </filter>
      <rect width="100%" height="100%" filter="url(#rq-paper-crumple)" opacity="0.55" />
    </svg>
  </div>
);
